import React from "react";
import { Drawer, Row, Col, Typography, Divider } from "antd";

const { Title, Text } = Typography;

interface PaymentDetails {
  plan_id: string;
  establishment_id: string;
  currency: string;
  finalized_at: string;
  status: string;
  name_establishment: string;
  full_name: string;
  email: string;
  creation_date: string;
  reference: string;
  plan_messages: number;
  plan_title: string;
  phone_number: string;
  amount: string;
  payment_reference: string;
  payment_method_type: string;
}

interface PaymentDrawerProps {
  open: boolean;
  onClose: () => void;
  paymentDetails: PaymentDetails | null;
}

const PaymentDrawer: React.FC<PaymentDrawerProps> = ({
  open,
  onClose,
  paymentDetails,
}) => {
  if (!paymentDetails) return null;

  return (
    <Drawer
      title={`Detalles de la Transacción: ${paymentDetails.payment_reference}`}
      open={open}
      onClose={onClose}
      width={500}
      placement="right"
    >
      <div>
        {/* Información de Referencias */}
        <Row>
          <Col span={12}>
            <Text strong>Referencia de Pago:</Text>
            <br />
            <Text>{paymentDetails.payment_reference}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Referencia:</Text>
            <br />
            <Text>{paymentDetails.reference}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Información del Establecimiento */}
        <Row>
          <Col span={24}>
            <Text strong>Establecimiento:</Text>
            <br />
            <Text>{paymentDetails.name_establishment}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Información del Plan */}
        <Row>
          <Col span={12}>
            <Text strong>Título del Plan:</Text>
            <br />
            <Text>{paymentDetails.plan_title}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Mensajes del Plan:</Text>
            <br />
            <Text>{paymentDetails.plan_messages}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Monto y Estado */}
        <Row>
          <Col span={12}>
            <Text strong>Monto (COP):</Text>
            <br />
            <Text>{paymentDetails.amount}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Estado:</Text>
            <br />
            <Text>{paymentDetails.status}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Método de Pago y Moneda */}
        <Row>
          <Col span={12}>
            <Text strong>Método de Pago:</Text>
            <br />
            <Text>{paymentDetails.payment_method_type}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Moneda:</Text>
            <br />
            <Text>{paymentDetails.currency}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Fechas */}
        <Row>
          <Col span={12}>
            <Text strong>Fecha de Finalización:</Text>
            <br />
            <Text>{paymentDetails.finalized_at}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Fecha de Transacción:</Text>
            <br />
            <Text>
              {new Date(paymentDetails.creation_date).toLocaleString()}
            </Text>
          </Col>
        </Row>
        <Divider />

        {/* Contacto */}
        <Row>
          <Col span={12}>
            <Text strong>Número de Teléfono:</Text>
            <br />
            <Text>{paymentDetails.phone_number}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Correo Electrónico:</Text>
            <br />
            <Text>{paymentDetails.email}</Text>
          </Col>
        </Row>
        <Divider />

        {/* Nombre Completo */}
        <Row>
          <Col span={24}>
            <Text strong>Nombre Completo:</Text>
            <br />
            <Text>{paymentDetails.full_name}</Text>
          </Col>
        </Row>
      </div>
    </Drawer>
  );
};

export default PaymentDrawer;
